import React from 'react';
import { useTranslation } from 'react-i18next';
import BreadCrumbs from "../../../../components/BreadCrumbs/BreadCrumbs";
import PageList from "../../../../components/Constant/List/List";
import HeroRightImage from "../../../../components/Constant/HeroRightImage/HeroRightImage";
import HeroImage from "../../../../assets/images/area/ready-made-image.png";
import SEO from "../../../../utils/SEO";

function ReadyMade () {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.ready-made.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    const BreadCrumbsData = [
        { name: tp('breadcrumb.home', 'Offshore Advisory'), link: '/' },
        { name: tp('breadcrumb.self', 'Ready Made'), link: '/ready-made' },
    ];

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/ready-made"
            />
            <section
                className='banking-license-section section'
            >
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>
                        {tp('h1')}
                    </h1>
                    <div className='grid-container'>
                        <div className='flex-start'>

                            <PageList items={obj('prices.items')}/>


                            <p className='page-paragraph'>
                                {tp('p1')}
                            </p>

                            <h2 className='page-title'>
                                {tp('included.title')}
                            </h2>
                            <p>{tp('included.lead')}</p>
                            <PageList items={obj('included.items')}/>
                        </div>
                        <HeroRightImage src={HeroImage}/>
                    </div>


                    <div className='flex-start'>
                        <h2 className='page-title'>
                            {tp('jurisdictions.title')}
                        </h2>
                        <p className='page-subtitle'>{tp('jurisdictions.subtitle')}</p>
                        <PageList items={obj('jurisdictions.items')}/>
                    </div>

                    <div className='flex-start'>
                        <h2 className='page-title'>
                            {tp('useCases.title')}
                        </h2>
                        <p className='page-subtitle'>{tp('useCases.subtitle')}</p>
                        <PageList items={obj('useCases.items')}/>
                    </div>

                    <div className='flex-start'>
                        <h2 className='page-title'>
                            {tp('documents.title')}
                        </h2>
                        <p className='page-subtitle'>{tp('documents.subtitle')}</p>
                        <PageList items={obj('documents.items')}/>
                    </div>
                    <div className='flex-start'>
                        <h2 className='page-title'>
                            {tp('delivery.title')}
                        </h2>
                        <p className='page-subtitle'>{tp('delivery.subtitle')}</p>
                        <PageList items={obj('delivery.items')}/>
                    </div>
                    <div className='flex-start'>
                        <h2 className='page-title'>
                            {tp('price.title')}
                        </h2>
                        <p className='page-subtitle'>{tp('price.subtitle')}</p>
                        <PageList items={obj('price.items')}/>
                    </div>
                    <div className='flex-start'>
                        <h2 className='page-title'>
                            {tp('confidentiality.title')}
                        </h2>
                        <p className='page-subtitle'>{tp('confidentiality.text')}</p>
                    </div>

                </div>


            </section>
        </main>
    )
        ;
}

export default ReadyMade;
